import { LiveEvent as Event, YammerState } from '../../state/types';
import { isUserAcceptanceRequired } from '../restrictedPostingAcceptance/selectors';

import {
  findLiveEventWithoutStatusByBroadcastIdThrows,
  isCurrentUserAttendeeThrows,
  isCurrentUserEventAdminThrows,
} from './selectors';

type ShowRestrictedPostingWarningBarToUserThrows = (state: YammerState, broadcastId: Event['broadcastId']) => boolean;
export const showRestrictedPostingWarningBarToUserThrows: ShowRestrictedPostingWarningBarToUserThrows = (
  state,
  broadcastId
) => {
  const isAdmin = isCurrentUserEventAdminThrows(state, broadcastId);
  const { isThreadStarterRestricted, canStartThread } = findLiveEventWithoutStatusByBroadcastIdThrows(
    state,
    broadcastId
  );

  return isAdmin && isThreadStarterRestricted && canStartThread;
};

type ShowAttendeeRestrictedErrorBar = (state: YammerState, broadcastId: Event['broadcastId']) => boolean;
export const showAttendeeRestrictedErrorBar: ShowAttendeeRestrictedErrorBar = (state, broadcastId) => {
  const isAttendee = isCurrentUserAttendeeThrows(state, broadcastId);
  const { isThreadStarterRestricted } = findLiveEventWithoutStatusByBroadcastIdThrows(state, broadcastId);
  const userAcceptanceRequired = isUserAcceptanceRequired(state);

  return isAttendee && isThreadStarterRestricted && userAcceptanceRequired;
};

type ShowEventPublisherToUser = (state: YammerState, broadcastId: Event['broadcastId']) => boolean;
export const showEventPublisherToUser: ShowEventPublisherToUser = (state, broadcastId) => {
  const isAdmin = isCurrentUserEventAdminThrows(state, broadcastId);

  if (isAdmin) {
    return true;
  }

  const { isThreadStarterRestricted } = findLiveEventWithoutStatusByBroadcastIdThrows(state, broadcastId);
  const userAcceptanceRequired = isUserAcceptanceRequired(state);

  return isThreadStarterRestricted === userAcceptanceRequired;
};

type ShowAttendeeInfoBar = (state: YammerState, broadcastId: Event['broadcastId']) => boolean;
export const showAttendeeInfoBar: ShowAttendeeInfoBar = (state, broadcastId) => {
  const isAttendee = isCurrentUserAttendeeThrows(state, broadcastId);
  const { isThreadStarterRestricted } = findLiveEventWithoutStatusByBroadcastIdThrows(state, broadcastId);
  const userAcceptanceRequired = isUserAcceptanceRequired(state);

  return isAttendee && !isThreadStarterRestricted && userAcceptanceRequired;
};
